// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.criteria-rules-modal .cald-modal-body .vol-reqs-table tr th {
  font-family: "72-Regular";
}

.criteria-rules-action-modal .modal-content {
  width: 100% !important;
}

ss-multiselect-dropdown .dropdown-menu {
  z-index: 1055 !important;
}

ss-multiselect-dropdown .dropdown-inline {
  width: 94px !important;
  min-width: 94px !important;
  max-width: 94px !important;
}

.criteria-rules-modal .no-rules-text {
  background-color: #f2fbfe;
}
.criteria-rules-modal .modal-content {
  width: 100% !important;
}
.criteria-rules-modal .cald-modal-body {
  max-height: 30rem;
  min-height: 20rem;
  overflow-x: auto;
  overflow-y: visible;
}
.criteria-rules-modal .cald-modal-body .vol-reqs-table tr th {
  font-size: 1.2rem;
  color: #6a6d70;
  padding: 0;
  padding-bottom: 0 !important;
  font-weight: normal;
}
.criteria-rules-modal .cald-modal-body .vol-reqs-table tr th,
.criteria-rules-modal .cald-modal-body .vol-reqs-table tr td {
  border: none;
  padding: 0.5rem;
}

.position-relative {
  position: relative !important;
}

ng-multiselect-dropdown {
  display: block;
  width: 100%;
}

td.position-relative {
  overflow: visible !important;
}

.dropdown-list-position .dropdown-list {
  position: fixed !important;
  z-index: 2000 !important;
}

.modal-custom-width.modal-dialog {
  min-width: 87rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/components/application/planbuilder/compRateCard/criteria-rate-modal/criteria-rate-modal.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AAAE;EACE,sBAAA;AAGJ;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,sBAAA;EACA,0BAAA;EACA,0BAAA;AAEF;;AAEE;EACE,yBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AAEE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGQ;EACE,iBAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;EACA,mBAAA;AAFV;AAIQ;;EAEE,YAAA;EACA,eAAA;AAFV;;AASA;EACE,6BAAA;AANF;;AASA;EACE,cAAA;EACA,WAAA;AANF;;AASA;EACE,4BAAA;AANF;;AASA;EACE,0BAAA;EACA,wBAAA;AANF;;AAUE;EAEE,2BAAA;AARJ","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../../../../assets/css/fonts';\n\n.criteria-rules-action-modal {\n  .modal-content {\n    width: 100% !important;\n  }\n}\n\nss-multiselect-dropdown .dropdown-menu {\n  z-index: 1055 !important;\n}\n\nss-multiselect-dropdown .dropdown-inline {\n  width: 94px !important;\n  min-width: 94px !important;\n  max-width: 94px !important;\n}\n\n.criteria-rules-modal {\n  .no-rules-text {\n    background-color: #f2fbfe;\n  }\n  .modal-content {\n    width: 100% !important;\n  }\n\n  .cald-modal-body {\n    max-height: 30rem;\n    min-height: 20rem;\n    overflow-x: auto;\n    overflow-y: visible;\n    .vol-reqs-table {\n      tr {\n        th {\n          font-size: 1.2rem;\n          color: #6a6d70;\n          padding: 0;\n          @extend %font-regular;\n          padding-bottom: 0 !important;\n          font-weight: normal;\n        }\n        th,\n        td {\n          border: none;\n          padding: 0.5rem;\n        }\n      }\n    }\n  }\n}\n\n.position-relative {\n  position: relative !important;\n}\n\nng-multiselect-dropdown {\n  display: block;\n  width: 100%;\n}\n\ntd.position-relative {\n  overflow: visible !important;\n}\n\n.dropdown-list-position .dropdown-list {\n  position: fixed !important;\n  z-index: 2000 !important;\n}\n\n.modal-custom-width {\n  &.modal-dialog {\n    // This will replace default width of the modal which is set in modal.scss\n    min-width: 87rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
